import React from 'react'
import PageHeader from '../common/ui/pageheader' // Reusable header component with title, subtitle & button

// Customerheading Component
// Props:
// - onAddClick: Function to handle "Add Customer" button click
export default function Customerheading({ onAddClick }) {
  return (
    <PageHeader
      title="Add Customer" // Main heading text
      subtitle="Here you can record arriving materials." // Sub-heading/description
      buttonText="Add Customer" // Text displayed on the button
      onButtonClick={onAddClick} // Event handler when button is clicked
    />
  )
}
